import React from 'react';
import { Trans } from '@lingui/macro';
import {
  TAddType,
} from '@goldwasserexchange/oblis-frontend-utils';
import { useHookstate } from '@hookstate/core';
import { useUser } from '../utils';

const TAddZipLabelMoralPart = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const userState = useUser();
  const tAddTypeState = useHookstate(userState.T_ADD_type);
  if (tAddTypeState.get() !== TAddType.MORAL) {
    return null;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export const tAddZipLabel = (
  <Trans>
    Code postal
    <TAddZipLabelMoralPart>&#32;du siège social</TAddZipLabelMoralPart>
  </Trans>
);
